export const MENUS = {
    DASHBOARD: 'dashboard',
    CADASTRO: 'cadastro',
    FUNCIONALIDAES: 'funcionalidades',
    FINANCEIRO: 'financeiro',
    SISTEMA: 'sistema',
    MEUSDADOS: 'areaCliente'

}
